import { useGetById } from './useGetById'
import { useIsEligibleForProgram, usePerformanceSummary } from './usePerformanceSummary'
import { useProgramInstanceDetail } from './useProgramInstanceDetail'
import { useUnifiedOverview } from './useUnifiedOverview'

export const programs = {
  getById: useGetById,
  programInstanceDetail: useProgramInstanceDetail,
  performanceSummary: usePerformanceSummary,
  unifiedOverview: useUnifiedOverview,
  isEligibleForProgram: useIsEligibleForProgram,
}
